import { BiHomeAlt } from "react-icons/bi";
import { FiEdit, FiLogIn, FiLayers,FiAlertCircle } from "react-icons/fi";
import { MdOutlineAccountCircle } from "react-icons/md";
import icon from "../Assets/img/VUSA_Icon.png";

export const api_url = `${process.env.REACT_APP_API_URL}`;
export const SESSION_USER = "user";
export const SESSION_TOKEN = "token";
export const SESSION_EXPIRE = "expire";

export const authTitles = new Map()
  .set("login/sign-up", "COMPLETAR REGISTRO")
  .set("login", "INICIAR SESIÓN")
  .set("login/sign-google", "COMPLETAR REGISTRO")
  .set("verify", "VERIFICAR CORREO ELECTRÓNICO")
  .set("change-password", "CAMBIAR CONTRASEÑA");

export const DOCUMENT = "C";
export const PASSPORT = "PP";
export const DOMINICAN = 1;
export const WITHCREDENTIALS = 1;
export const WITHGOOGLE = 2;

export const noAuthMenuVusa = [
  { icon: <BiHomeAlt></BiHomeAlt>, title: "Inicio", redirect: "/" },
  { icon: <FiEdit></FiEdit>, title: "Registrarse", redirect: "login/sign-up" },
  { icon: <FiLogIn></FiLogIn>, title: "Iniciar Sesión", redirect: "login" },
  {
    icon: <FiLayers></FiLayers>,
    title: "Catálogo",
    redirect: "/service-catalog",
  },
  {
    icon: <FiAlertCircle></FiAlertCircle>,
    title: "Reclamación",
    redirect: "/reclamacion",
  }

];

export const noAuthMenuSinap = [
  {
    icon: <BiHomeAlt></BiHomeAlt>,
    title: "Inicio",
    redirect: "/",
  },
  { icon: <FiEdit></FiEdit>, title: "Registrarse", redirect: "/login/sign-up" },
  { icon: <FiLogIn></FiLogIn>, title: "Iniciar Sesión", redirect: "/login" },
  {
    icon: <FiLayers></FiLayers>,
    title: "Catálogo",
    redirect: "/catalog",
  },
  {
    icon: <FiAlertCircle></FiAlertCircle>,
    title: "Reclamación",
    redirect: "/reclamacion",
  }
];

export const authMenuSinap = [
  {
    icon: <BiHomeAlt></BiHomeAlt>,
    title: "Inicio",
    redirect: "/",
  },
  {
    icon: <MdOutlineAccountCircle></MdOutlineAccountCircle>,
    title: "Mi cuenta",
    redirect: "/user",
  },
  {
    icon: <FiLayers></FiLayers>,
    title: "Catálogo",
    redirect: "/catalog",
  },
  {
    icon: <FiAlertCircle></FiAlertCircle>,
    title: "Reclamación",
    redirect: "/reclamacion",
  },
  // {
  //   icon: <FiAlertCircle></FiAlertCircle>,
  //   title: "Historial de compras",
  //   redirect: "/historialcompras",
  // }
  
];

export const authMenuVusa = [
  { icon: <BiHomeAlt></BiHomeAlt>, title: "Inicio", redirect: "/" },
  {
    icon: <MdOutlineAccountCircle></MdOutlineAccountCircle>,
    title: "Mi cuenta",
    redirect: "/user",
  },
  {
    icon: <FiLayers></FiLayers>,
    title: "Catálogo",
    redirect: "/service-catalog",
  },
  {
    icon: <FiAlertCircle></FiAlertCircle>,
    title: "Reclamación",
    redirect: "/reclamacion",
  }
];
